/**
 * Created by henian.xu on 2018/7/19.
 *
 */

import { HttpBase } from '@/api/base/HttpBase';

class Fn extends HttpBase {
    constructor() {
        super();
        this.baseUrl += '/fn';
    }
}

export default new Fn();
export { Fn };
